export { GettingStarted as default } from './GettingStarted';